/* BB BATTLE BANDS — bb-bands.js */
(function () {
  'use strict';

  const wrap = document.querySelector('.bb-bands');
  if (!wrap) return;

  /* ── Gallery ── */
  const mainImg = document.getElementById('bb-bands-main-img');
  const thumbs = wrap.querySelectorAll('.bb-bands__gallery-thumb');
  const prevBtn = wrap.querySelector('.bb-bands__gallery-arrow--prev');
  const nextBtn = wrap.querySelector('.bb-bands__gallery-arrow--next');
  let currentIdx = 0;

  /* Build mobile dot indicators */
  const galleryMain = wrap.querySelector('.bb-bands__gallery-main');
  let dotsWrap = null;
  if (thumbs.length > 1) {
    dotsWrap = document.createElement('div');
    dotsWrap.className = 'bb-bands__gallery-dots';
    thumbs.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'bb-bands__gallery-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', () => setThumb(i));
      dotsWrap.appendChild(dot);
    });
    if (galleryMain && galleryMain.parentNode) {
      galleryMain.parentNode.insertBefore(dotsWrap, galleryMain.nextSibling);
    }
  }

  function setThumb(idx) {
    if (!thumbs[idx]) return;
    currentIdx = idx;
    const src = thumbs[idx].dataset.src;
    const alt = thumbs[idx].dataset.alt || '';
    mainImg.style.opacity = '0.6';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.alt = alt;
      mainImg.style.opacity = '1';
    }, 100);
    thumbs.forEach(t => t.classList.remove('is-active'));
    thumbs[idx].classList.add('is-active');
    thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    // Update dots
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.bb-bands__gallery-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === idx);
      });
    }
  }

  thumbs.forEach((btn, i) => btn.addEventListener('click', () => setThumb(i)));
  if (prevBtn) prevBtn.addEventListener('click', () => setThumb((currentIdx - 1 + thumbs.length) % thumbs.length));
  if (nextBtn) nextBtn.addEventListener('click', () => setThumb((currentIdx + 1) % thumbs.length));

  /* Touch swipe support for mobile */
  if (galleryMain) {
    let touchStartX = 0;
    galleryMain.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        setThumb(dx < 0
          ? (currentIdx + 1) % thumbs.length
          : (currentIdx - 1 + thumbs.length) % thumbs.length);
      }
    }, { passive: true });
  }

  /* ── Quantity ── */
  const qtyInput = document.getElementById('bb-bands-qty');
  const qtyMinus = document.getElementById('bb-bands-qty-minus');
  const qtyPlus = document.getElementById('bb-bands-qty-plus');

  if (qtyMinus) qtyMinus.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
  });
  if (qtyPlus) qtyPlus.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value || 1) + 1;
  });

  /* ── Variant Data (from embedded JSON) ── */
  let productVariants = [];
  const productJsonEl = document.getElementById('bb-bands-product-json');
  if (productJsonEl) {
    try {
      const parsed = JSON.parse(productJsonEl.textContent);
      productVariants = parsed.variants || [];
    } catch(e) {
      console.warn('[bb-bands] Could not parse product JSON', e);
    }
  }

  /* ── Variant Swatches ── */
  const swatches = wrap.querySelectorAll('.bb-bands__swatch');
  const atcBtn = document.getElementById('bb-bands-atc');
  const priceEl = document.getElementById('bb-bands-price');

  let selectedOptions = {};
  swatches.forEach(btn => {
    const idx = btn.dataset.optionIndex;
    if (!(idx in selectedOptions)) {
      if (btn.classList.contains('is-selected')) selectedOptions[idx] = btn.dataset.value;
    }
  });

  swatches.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      const idx = btn.dataset.optionIndex;
      const val = btn.dataset.value;
      selectedOptions[idx] = val;

      // Update UI
      wrap.querySelectorAll(`.bb-bands__swatch[data-option-index="${idx}"]`).forEach(b => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      // Update label
      const labelSpan = wrap.querySelector(`#bb-bands-option-val-${parseInt(idx) + 1}`);
      if (labelSpan) labelSpan.textContent = val;

      // Find matching variant and update UI
      resolveVariant();
      markUnavailableSwatches();
    });
  });

  function resolveVariant() {
    if (!productVariants.length) return;
    const match = productVariants.find(v => {
      return Object.entries(selectedOptions).every(([idx, val]) => {
        return v.options[parseInt(idx)] === val;
      });
    });
    if (!match) {
      atcBtn.disabled = true;
      atcBtn.textContent = atcBtn.dataset.soldText || 'Sold Out';
      return;
    }

    // Update ATC button variant ID (as integer)
    atcBtn.dataset.variantId = match.id;

    // Update availability
    const isPreorder = (
      match.inventory_management === 'shopify' &&
      match.inventory_policy === 'continue' &&
      match.inventory_quantity <= 0
    );

    if (match.available) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>` + (isPreorder ? 'Pre-Order' : (atcBtn.dataset.atcText || 'Add to Cart'));
    } else {
      atcBtn.disabled = true;
      atcBtn.textContent = 'Sold Out';
    }

    // Update price
    if (priceEl) {
      priceEl.textContent = '$' + (match.price / 100).toFixed(2);
    }

    // Update inventory status
    const invText = wrap.querySelector('.bb-bands__inventory');
    if (invText) {
      if (isPreorder) {
        invText.innerHTML = `<span class="bb-bands__dot" style="background:#9A9871;"></span> Pre-Order`;
      } else if (match.available) {
        invText.innerHTML = `<span class="bb-bands__dot bb-bands__dot--in"></span> In Stock`;
      } else {
        invText.innerHTML = `<span class="bb-bands__dot bb-bands__dot--out"></span> Sold Out`;
      }
    }

    // Update pre-order badge
    const preorderBadge = wrap.querySelector('[data-preorder-badge]');
    if (preorderBadge) preorderBadge.classList.toggle('hide', !isPreorder);

    // Update URL
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }
  }

  function markUnavailableSwatches() {
    if (!productVariants.length) return;
    wrap.querySelectorAll('.bb-bands__option').forEach((optEl, optIdx) => {
      optEl.querySelectorAll('.bb-bands__swatch').forEach(btn => {
        const testOptions = Object.assign({}, selectedOptions);
        testOptions[optIdx] = btn.dataset.value;
        const available = productVariants.some(v =>
          Object.entries(testOptions).every(([i, val]) => val === null || v.options[parseInt(i)] === val) && v.available
        );
        btn.disabled = !available;
        btn.style.opacity = available ? '' : '0.35';
      });
    });
  }

  // Run initial unavailable check
  resolveVariant();
  markUnavailableSwatches();

  /* ── Add to Cart ── */
  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      const variantId = atcBtn.dataset.variantId;
      const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;
      if (!variantId || atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

      atcBtn.classList.add('is-loading');
      const originalText = atcBtn.innerHTML;
      atcBtn.innerHTML = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      })
        .then(r => {
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(() => {
          atcBtn.innerHTML = '✓ Added!';
          setTimeout(() => {
            atcBtn.innerHTML = originalText;
            atcBtn.classList.remove('is-loading');
          }, 1800);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const cartIcon = document.querySelector('[data-cart-toggle], .cart-toggle, #cart-icon-bubble');
          if (cartIcon) cartIcon.click();
        })
        .catch(() => {
          atcBtn.innerHTML = 'Error — Try Again';
          atcBtn.classList.remove('is-loading');
          setTimeout(() => { atcBtn.innerHTML = originalText; }, 2000);
        });
    });
  }



  /* ── Pairs Well With (quick-add upsell) ── */
  wrap.querySelectorAll('.bb-bands__pairs-item').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId || this.disabled) return;

      const meta = this.querySelector('.bb-bands__pairs-add');
      const originalAddText = meta ? meta.innerHTML : null;
      this.disabled = true;
      this.classList.add('is-loading');
      if (meta) meta.innerHTML = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
        .then(r => {
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(() => {
          if (meta) meta.innerHTML = '✓ Added';
          this.classList.remove('is-loading');
          this.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          const cartIcon = document.querySelector('[data-cart-toggle], .cart-toggle, #cart-icon-bubble');
          if (cartIcon) cartIcon.click();
          setTimeout(() => {
            if (meta) meta.innerHTML = originalAddText;
            this.classList.remove('is-added');
            this.disabled = false;
          }, 2000);
        })
        .catch(() => {
          if (meta) meta.innerHTML = 'Error';
          this.classList.remove('is-loading');
          setTimeout(() => {
            if (meta) meta.innerHTML = originalAddText;
            this.disabled = false;
          }, 2000);
        });
    });
  });

    /* ── Accordion ── */
  wrap.querySelectorAll('.bb-bands__accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.bb-bands__accordion-item');
      item.classList.toggle('is-open');
    });
  });

  /* ── Sticky ATC Bar ── */
  const stickyBar = document.getElementById('bb-bands-sticky');
  const stickyAtcBtn = document.getElementById('bb-bands-sticky-atc');
  const stickyPriceEl = document.getElementById('bb-bands-sticky-price');

  if (stickyBar && atcBtn) {
    // Show sticky bar when main ATC scrolls out of view
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );
    observer.observe(atcBtn);

    // Keep sticky price in sync with variant changes
    if (stickyPriceEl && priceEl) {
      const priceObserver = new MutationObserver(() => {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    // Keep sticky variant ID in sync
    if (stickyAtcBtn) {
      function syncStickyButton() {
        stickyAtcBtn.dataset.variantId = atcBtn.dataset.variantId;
        stickyAtcBtn.disabled = atcBtn.disabled || atcBtn.classList.contains('is-loading');
        stickyAtcBtn.textContent = atcBtn.textContent.trim();
      }
      const variantObserver = new MutationObserver(syncStickyButton);
      variantObserver.observe(atcBtn, {
        attributes: true,
        attributeFilter: ['data-variant-id', 'disabled', 'class'],
        childList: true,
        characterData: true,
        subtree: true
      });
      syncStickyButton();
      stickyAtcBtn.addEventListener('click', () => {
        if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;
        atcBtn.click();
      });
    }
  }

})();





/* ── Variant extras: pre-order ship date, variant note, variant photo (added 2026-10-18) ──
   For variants that carry the variant metafields custom.preorder_lead_days and/or
   custom.variant_note (MK 2.5 Camo on the Hybrid Vest), this:
     - shows "Ships in X days · projected <date>" under the buy button while that variant is at
       zero stock and set to keep selling (the button already reads Pre-Order in that state),
     - shows the variant note under it,
     - jumps the gallery to the variant's own photo when a shopper picks it,
     - turns the option buttons into photo swatches (photo, name, price, optional badge),
     - shows a "See it in action" video player under the buy section when the product sets
       custom.pdp_video_heading.
   Data comes from the product.bbpo alternate template (?view=bbpo). Products whose variants
   have neither metafield are left exactly as they were. */
(function () {
  'use strict';
  var wrap = document.querySelector('.bb-bands');
  var atc = document.getElementById('bb-bands-atc');
  var jsonEl = document.getElementById('bb-bands-product-json');
  if (!wrap || !atc || !jsonEl) return;
  var variants = [];
  try { variants = JSON.parse(jsonEl.textContent).variants || []; } catch (e) { return; }
  if (variants.length < 2) return;
  var path = window.location.pathname.replace(/\/+$/, '');
  if (path.indexOf('/products/') === -1) return;

  function pathOf(src) {
    if (!src) return '';
    return String(src).split('?')[0].replace(/^https?:/, '').replace(/^\/\/[^\/]+/, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function byId(id) {
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
    return null;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }

  fetch(path + '?view=bbpo', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.text() : null; })
    .then(function (txt) {
      if (!txt) return;
      var po;
      try { po = JSON.parse(txt); } catch (e) { return; }
      try { renderVideos(po); } catch (e) {}
      var map = po && po.variants;
      if (!map) return;
      var used = Object.keys(map).some(function (k) { return (map[k].days > 0) || map[k].note || map[k].badge; });
      if (used) init(map);
    })
    .catch(function () {});

  // "See it in action" player: Shopify-hosted product videos, shown under the buy section only
  // on products that set the product metafield custom.pdp_video_heading (the vest).
  function renderVideos(po) {
    if (!po || !po.video_heading || !po.videos || !po.videos.length) return;
    var hero = wrap.querySelector('.bb-bands__hero');
    if (!hero || document.querySelector('.bb-pdp-video')) return;
    var css = document.createElement('style');
    css.textContent =
      '.bb-pdp-video{padding:48px 24px 40px;text-align:center;background:#fff}' +
      '.bb-pdp-video h2{font-family:"PP Monument Extended",sans-serif;font-size:clamp(20px,3vw,32px);font-weight:800;text-transform:uppercase;letter-spacing:.04em;color:#0B0B0B;margin:0 0 20px}' +
      '.bb-pdp-video__row{display:flex;flex-wrap:wrap;justify-content:center;gap:16px}' +
      '.bb-pdp-video__frame{position:relative;width:100%;max-width:360px;aspect-ratio:9/16;background:#0B0B0B;overflow:hidden}' +
      '.bb-pdp-video__frame video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#0B0B0B}';
    document.head.appendChild(css);
    var sec = document.createElement('section');
    sec.className = 'bb-pdp-video';
    var html = '<h2>' + esc(po.video_heading) + '</h2><div class="bb-pdp-video__row">';
    po.videos.forEach(function (v) {
      if (!v || !v.src) return;
      html += '<div class="bb-pdp-video__frame"><video controls playsinline preload="metadata"' +
        (v.poster ? ' poster="' + esc(v.poster) + '"' : '') +
        (v.alt ? ' aria-label="' + esc(v.alt) + '"' : '') +
        '><source src="' + esc(v.src) + '" type="video/mp4"></video></div>';
    });
    html += '</div>';
    sec.innerHTML = html;
    hero.insertAdjacentElement('afterend', sec);
  }

  function init(map) {
    var row = wrap.querySelector('.bb-bands__atc-row');
    if (!row) return;
    var style = document.createElement('style');
    style.textContent =
      '.bb-po-variant{margin:12px 0 2px;width:100%;box-sizing:border-box}' +
      '.bb-po-variant .bb-po-ship{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;padding:11px 14px;' +
      'background:rgba(154,152,113,0.12);border:1px solid #9A9871;border-radius:0;color:#161616;font-size:14px;font-weight:700;' +
      'letter-spacing:.3px;line-height:1.25;text-align:center}' +
      '.bb-po-variant .bb-po-ship small{font-size:inherit;font-weight:500;color:#7c7a52;letter-spacing:.2px}' +
      '.bb-po-variant .bb-po-ship small::before{content:"\\00B7";margin-right:6px;color:#9A9871}' +
      '.bb-po-variant .bb-po-note{margin-top:8px;font-size:13px;line-height:1.4;color:#4a4936;text-align:center}' +
      '.bb-po-variant .bb-po-ship + .bb-po-note{margin-top:8px}' +
      '.bb-po-variant > .bb-po-note:first-child{margin-top:0}';
    document.head.appendChild(style);
    var box = document.createElement('div');
    box.className = 'bb-po-variant';
    box.hidden = true;
    row.insertAdjacentElement('afterend', box);

    var lastId = null;
    function swapImage(src) {
      var want = pathOf(src);
      if (!want) return;
      var thumbs = wrap.querySelectorAll('.bb-bands__gallery-thumb');
      for (var i = 0; i < thumbs.length; i++) {
        if (pathOf(thumbs[i].getAttribute('data-src')) === want) {
          if (!thumbs[i].classList.contains('is-active')) thumbs[i].click();
          return;
        }
      }
    }
    function update() {
      var id = atc.getAttribute('data-variant-id');
      var v = byId(id);
      var m = map[String(id)] || {};
      if (!v) { box.hidden = true; box.innerHTML = ''; return; }
      var isPre = v.inventory_management === 'shopify' && v.inventory_policy === 'continue' && v.inventory_quantity <= 0;
      var html = '';
      if (isPre && m.days > 0) {
        var d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + m.days);
        html += '<div class="bb-po-ship">🚚 <span>Ships in ' + m.days + ' day' + (m.days === 1 ? '' : 's') +
          '</span> <small>projected ' + fmt(d) + '</small></div>';
      }
      if (m.note) html += '<div class="bb-po-note">' + esc(m.note) + '</div>';
      box.innerHTML = html;
      box.hidden = !html;
      if (String(id) !== String(lastId)) { lastId = id; swapImage(m.image); }
    }
    // Photo swatches: each option button shows that variant's own photo, name and price
    // (plus an optional badge from custom.swatch_badge). All-or-nothing: if any variant
    // lacks a photo the buttons stay as plain text.
    (function photoSwatches() {
      var opts = wrap.querySelectorAll('.bb-bands__option');
      if (opts.length !== 1) return;
      var group = opts[0].querySelector('.bb-bands__swatches');
      var btns = opts[0].querySelectorAll('.bb-bands__swatch');
      if (!group || !btns.length) return;
      var ready = [];
      for (var i = 0; i < btns.length; i++) {
        var val = btns[i].getAttribute('data-value');
        var vv = null;
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].options && variants[k].options[0] === val) { vv = variants[k]; break; }
        }
        var mm = vv && map[String(vv.id)];
        if (!mm || !mm.image) return;
        ready.push({ btn: btns[i], img: mm.image, badge: mm.badge, price: vv.price });
      }
      var css = document.createElement('style');
      css.textContent =
        '.bb-bands__swatches.bb-photo-swatches{display:grid;grid-template-columns:repeat(' + ready.length + ',minmax(0,1fr));gap:10px;max-width:420px}' +
        '.bb-photo-swatches .bb-bands__swatch{position:relative;display:flex;flex-direction:column;align-items:stretch;padding:0;height:auto;min-height:0;min-width:0;width:100%;overflow:hidden;text-align:center;border-radius:0;white-space:normal}' +
        '.bb-photo-swatches .bb-sw-img{display:block;width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;background:#DADADA}' +
        '.bb-photo-swatches .bb-sw-label{display:block;padding:9px 6px 10px;font-size:12px;font-weight:700;letter-spacing:.6px;text-transform:uppercase;line-height:1.25}' +
        '.bb-photo-swatches .bb-sw-price{display:block;font-weight:500;letter-spacing:.2px;opacity:.75;margin-top:2px}' +
        '.bb-photo-swatches .bb-sw-badge{position:absolute;top:8px;left:8px;background:#9A9871;color:#fff;font-size:10px;font-weight:800;letter-spacing:.8px;padding:4px 7px;line-height:1;text-transform:uppercase}';
      document.head.appendChild(css);
      group.classList.add('bb-photo-swatches');
      ready.forEach(function (r) {
        var label = r.btn.textContent.trim();
        var price = (typeof r.price === 'number') ? ('$' + (r.price / 100).toFixed(2).replace(/\.00$/, '')) : '';
        r.btn.innerHTML = (r.badge ? '<span class="bb-sw-badge">' + esc(r.badge) + '</span>' : '') +
          '<img class="bb-sw-img" src="' + esc(String(r.img).replace(/width=\d+/, 'width=400')) + '" alt="" loading="eager">' +
          '<span class="bb-sw-label">' + esc(label) + (price ? '<span class="bb-sw-price">' + price + '</span>' : '') + '</span>';
      });
    })();

    update();
    try {
      new MutationObserver(update).observe(atc, { attributes: true, attributeFilter: ['data-variant-id'] });
    } catch (e) {}
  }
})();
